import { render } from "./Pane.vue?vue&type=template&id=152d7102&scoped=true"
import script from "./Pane.vue?vue&type=script&lang=js"
export * from "./Pane.vue?vue&type=script&lang=js"

import "./Pane.vue?vue&type=style&index=0&id=152d7102&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152d7102"]])

export default __exports__